import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "mb-0 max-w-[30rem] p-0" }
const _hoisted_2 = { class: "mt-4 block" }

import { computed, ref, watch } from 'vue'
import { useThrottleFn } from '@vueuse/core'
import { useRouter, useRoute } from 'vue-router'
import store from '@/store'

import SwordModal from '@/components/modals/SwordModal.vue'
// @ts-expect-error - Module resolution issue with @swordhealth/ui paths
import useActivityTracker from '@swordhealth/ui/composables/activity-tracker'
// @ts-expect-error - Module resolution issue with @swordhealth/ui paths
import useBroadcastTabChannel from '@swordhealth/ui/composables/broadcast-message'
// @ts-expect-error - Module resolution issue with @swordhealth/ui paths
import useTimer from '@swordhealth/ui/composables/timer'

import { AUTH_COOKIE, SESSION_TIMEOUT_CONFIG, CONFIG } from '@/scripts/app-configs/constants'

const THROTTLE_TIME = 3000
// Countdown time in seconds shown in the modal before auto logout
const MODAL_COUNTDOWN_SECONDS = 60

const resetActivityBroadcastType = 'update:user-activity-reset'
const requireManualActionBroadcastType = 'update:user-manual-action-required'
const userActionBroadcastType = 'update:user-activity-event'


export default /*@__PURE__*/_defineComponent({
  __name: 'TimeoutManager',
  emits: ["shown", "snooze", "expires"],
  setup(__props, { emit: __emit }) {

const router = useRouter()
const route = useRoute()

// Throttle events to prevent emitting from multiple tabs within 3 seconds
const emit = __emit

const { onMessage, postMessage } = useBroadcastTabChannel(CONFIG.broadcastChannelName)
const emitShown = useThrottleFn((remainingSeconds: number) => emit('shown', { remainingSeconds }), THROTTLE_TIME)
const emitSnooze = useThrottleFn((remainingSeconds: number) => emit('snooze', { remainingSeconds }), THROTTLE_TIME)
const emitExpires = useThrottleFn(() => emit('expires'), THROTTLE_TIME)

const showTimeoutModal = ref(false)
const fireUserIdled = computed(() => store.getters['user/authentication/isAuthenticated'])

const resetInactivity = (broadcastEv: boolean = true) => {
  if (broadcastEv) postMessage(userActionBroadcastType, resetActivityBroadcastType)
  updateDocumentTitleWithTimer()
  showTimeoutModal.value = false
  if (broadcastEv) emitSnooze(timeRemaining.value)
  resetIdle()
  resetTimer()
}

onMessage(userActionBroadcastType, (message: string) => {
  if (message === requireManualActionBroadcastType) requestManualAction()
  else if (message === resetActivityBroadcastType) resetInactivity(false)
})

const logoutUser = async () => {
  await store.dispatch('user/authentication/logout', { sameUserLoginRoute: route.fullPath })
  await router.replace({ name: 'logout' }).catch(() => {})
}

const onTimerEnds = async () => {
  emitExpires()
  resetInactivity(false)
  await logoutUser()
}

const updateDocumentTitleWithTimer = (currentTimer?: string) => {
  const TIMER_REGEX = /(\[[0-9]{2}:[0-9]{2}\]\s)?(.+)/g

  document.title = document.title.replace(TIMER_REGEX, (curr: string, timer: string, title: string) => {
    return currentTimer ? `[${currentTimer}] ${title}` : title
  })
}

const requestManualAction = () => {
  if (showTimeoutModal.value) return

  restartTimer()
  emitShown(timeRemaining.value)
  updateDocumentTitleWithTimer(stopWatch.value)
  showTimeoutModal.value = true
}

const { restart: restartTimer, reset: resetTimer, stopWatch, timeRemaining } = useTimer(MODAL_COUNTDOWN_SECONDS, onTimerEnds)
const { idle, resetIdle } = useActivityTracker({
  secondsUntilIdle: Number(SESSION_TIMEOUT_CONFIG.autoLogoutTimeout),
  activityCookieName: SESSION_TIMEOUT_CONFIG.sessionTimerStartCookieName,
  cookieDomain: AUTH_COOKIE.token_domain,
  listenForVisibilityChange: true,
})

// On tab boot, inform other tabs about it
postMessage(userActionBroadcastType, resetActivityBroadcastType)

watch(() => idle.value, (val: boolean) => {
  if (!val || !fireUserIdled.value) return
  // Ensure all tabs goes to manual action required state despite clock asynchronisms
  postMessage(userActionBroadcastType, requireManualActionBroadcastType)
  requestManualAction()
})

watch(() => stopWatch.value, (val: string) => {
  if (!showTimeoutModal.value) return
  updateDocumentTitleWithTimer(val)
})

return (_ctx: any,_cache: any) => {
  const _component_sword_button_wuk = _resolveComponent("sword-button-wuk")!

  return (showTimeoutModal.value)
    ? (_openBlock(), _createBlock(SwordModal, {
        key: 0,
        type: "warning",
        header: "copy_4416",
        onClose: resetInactivity
      }, {
        body: _withCtx(() => [
          _createElementVNode("p", _hoisted_1, _toDisplayString(_ctx.$t('copy_4417')), 1),
          _createElementVNode("span", _hoisted_2, _toDisplayString(_unref(stopWatch)), 1)
        ]),
        footer: _withCtx(() => [
          _createVNode(_component_sword_button_wuk, {
            theme: "primary",
            text: "copy_2",
            onClickNative: resetInactivity
          })
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})